import { useTranslation } from "react-i18next";
import { fmtDateTime, stateTone } from "./detailFmt";
import { fmtMoney } from "../../../lib/format";

const Cell = ({ label, children, tid }) => (
  <div className="flex flex-col items-center gap-1.5 px-3 py-2 text-center" data-testid={tid}>
    <span className="text-[11px] text-muted-foreground">{label}</span>
    <span className="text-sm font-bold">{children}</span>
  </div>
);

// شريط أعلى الصفحة: رقم الأمر · التاريخ · الحالة · الإجمالي.
export const DetailStats = ({ doc }) => {
  const { t } = useTranslation();
  return (
    <div className="mb-6 grid grid-cols-2 items-center gap-2 rounded-3xl bg-background p-3 shadow-neu sm:grid-cols-4"
         dir="rtl" data-testid="po-detail-stats">
      <Cell label={t("purchases.podetail.orderNo")} tid="stat-number">
        <span className="num font-mono text-primary">{doc.number || "—"}</span>
      </Cell>
      <Cell label={t("purchases.podetail.date")} tid="stat-date">
        <span className="num font-mono">{fmtDateTime(doc.created_at || doc.date)}</span>
      </Cell>
      <Cell label={t("purchases.podetail.state")} tid="stat-state">
        <span className={`rounded-full border px-3 py-1 text-[11px] font-bold ${stateTone(doc.state)}`}>
          {t(`purchases.states.${doc.state}`, doc.state)}
        </span>
      </Cell>
      <Cell label={t("purchases.podetail.grandTotal")} tid="stat-total">
        <span className="num font-mono text-emerald-600">
          {doc.money?.currency} {fmtMoney(doc.totals?.payable)}
        </span>
      </Cell>
    </div>
  );
};
